import * as THREE from '../../../external/THREE/three118'
var scene = new THREE.Scene()
export default scene
